export default __webpack_public_path__ + "static/media/reset.b6d30305.svg";